import React, { useEffect, useState, Fragment } from 'react';
import { Pagination, PageHeader, paginate } from '../../../Common';
import { TableContent, SoSTableContent } from '../../Common/Table/tableContent';
import MessageModal from '../../../UI/Modal/MessageModal';
import { Fields, validateProperty, validate, Card } from "../../Common";
import { sosSearchSchemaObject } from '../../Data';
import services from '../services';
import { search, SearchFeild } from '../../Common';
import $ from 'jquery';
import Joi from '@hapi/joi';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
const screenCode = 'SOS';

export function SOSListing(props) {

    const [packges, setPackges] = useState([]);
    const [operationEntities, setOperationEntities] = useState([]);
    const [groups, setGroups] = useState()
    const [sos, setSos] = useState({
        groupID: 0,
        operationEntityId: 0,
        aspNetUserId: 0,
        isActive: true,
        collectionPointID: 0
    });
    const [users, setUsers] = useState();
    const contentRowNames = ["packageCode", "packageName", "collectionPointName"]
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })
    const [collectionpoint, setCollectionpoint] = useState()
    const [isTableHide, setIsTableHide] = useState(true);
    const [permissionList, setPermissions] = useState({
        isSOSEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
        isFactoryWeighCompleteEnable:false,
        isFactoryWeighRequired : false
    });
    const schema = Joi.object(sosSearchSchemaObject).options({ allowUnknown: true })
    const [open, setOpen] = React.useState(false);
    const [selectedSosData, setSelectedSosData] = React.useState({});
    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntities()
            )
    }, [sos.groupID]);

    useEffect(() => {
        trackPromise(
            GetActiveAspNetUser(sos.groupID, sos.operationEntityId)
            )
        trackPromise(
            getCollectionPointsForDropDown(sos.operationEntityId, sos.groupID)
            )
        handleSearch();
    }, [sos.operationEntityId]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSOSLISTING');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isSOSEnabled = permissions.find(p => p.permissionCode == 'ENABLESOS');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        var isFactoryWeighCompleteEnable = permissions.find(p => p.permissionCode == 'FACTORYWEIGHCOMPLETE');
        var isFactoryWeighRequired = permissions.find(p => p.permissionCode == 'FACTORYWEIGHREQUIRED');
        setPermissions({
            ...permissionList,
            isSOSEnabled: isSOSEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !==undefined,
            isFactoryWeighCompleteEnable:isFactoryWeighCompleteEnable!=undefined,
            isFactoryWeighRequired:isFactoryWeighRequired!=undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSos({
            ...sos,
            groupID: token.groupID,
            operationEntityId: token.operationEntityID
        });
        
        getAllGroups();
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    async function getOperationEntities() {
        var data = await services.getAllOperationEntitiesForDropDown(sos.groupID);
        setOperationEntities(data);
    }

    async function getUsers() {
        var data = await services.getAllUsers(sos.groupID, sos.operationEntityId);
        setUsers(data);
    }

    async function GetActiveAspNetUser() {
        var data = await services.GetActiveAspNetUser(sos.groupID, sos.operationEntityId);
        setUsers(data);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoints = await services.GetAllCollectionPoints(sos.operationEntityId, sos.groupID);
        setCollectionpoint(collectionPoints);
    }

    async function handleClick(sosData) {

        setSelectedSosData(sosData);

        if(permissionList.isFactoryWeighRequired){
            const response = await services.CheckFactoryWeighComleted(parseInt(sosData.packageID));
            if(response.data!=null && response.data==2){
                handleClickOpen();
            }else if(response.data!=null && response.data==1){
                await startSos(sosData);
            }
        }else{
            await startSos(sosData);
        }
    }

    async function startSos(sosData){
         const response = await services.startSession(sosData);

        if (response.data) {
            response.message = "SOS Created Successfully";

            const responsex = await services.searchPackage(sos);
            if (responsex.data == null || responsex.data == undefined) {
                setIsTableHide(true)
            }
            else {
                setIsTableHide(false);
                destroyDataTable();
                setPackges(responsex.data);
                createDataTable();
            }

        } else {
            response.message = "SOS Creation Error!"
        }
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })

        setTimeout(() => {
            modalDismissHandler();
        }, 1500);
    }

    async function Proceed(){
        let result = selectedSosData;
        await startSosWithFacWeighment(result);
    }

    async function startSosWithFacWeighment(sosData){
        const response = await services.startSessionWithCompletingFacWeighment(sosData);

       if (response.data) {
           response.message = "SOS Created Successfully";

           const responsex = await services.searchPackage(sos);
           if (responsex.data == null || responsex.data == undefined) {
               setIsTableHide(true)
           }
           else {
               setIsTableHide(false);
               destroyDataTable();
               setPackges(responsex.data);
               createDataTable();
           }

       } else {
           response.message = "SOS Creation Error!"
       }
       handleClose();
       setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })

       setTimeout(() => {
           modalDismissHandler();
       }, 1500);
   }


    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function generateDropDownMenu(data) {

        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function handleChange(e) {
        const target = e.target
        const value = (target.name === 'isActive' || target.name === 'isErpEnabled') ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, sosSearchSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]
        if (e.target.name == "groupID") {
            setSos({
                groupID: value,
                operationEntityId: 0,
                aspNetUserId: 0,
                isActive: true,
                collectionPointID: 0
            })
        }else if(e.target.name == "operationEntityId") {
            setSos({
                groupID: sos.groupID,
                operationEntityId: value,
                aspNetUserId: 0,
                isActive: true,
                collectionPointID: 0
            })
        }
        else{
                setSos({
                    ...sos,
                    [e.target.name]: value
                })
            }
        

        setErrors(error)
    }

    async function handleSearch(e) {

        if(e !== undefined){
            const errorMessages = validate(schema, sos)
            errorMessages !== null ? setErrors(errorMessages) : setErrors({})
            if (errorMessages) return
        }

        const response = await services.searchPackage(sos);
        if (response.data == null || response.data == undefined) {
            setIsTableHide(true)
        }
        else {
            setIsTableHide(false);
            destroyDataTable();
            setPackges(response.data);
            createDataTable();
        }

    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {

            setTimeout(() => {
                props.history.push({ pathname: '/factories' })
            }, 1500);
        }
    }

    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result)
    }

    useEffect(() => {
        trackPromise(
        getAllGroups()
        )
  
    }, []);

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setSos({
            ...sos,
            groupID: permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityId: permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionPointID: '0',
            aspNetUserId: '0',
        });
        setPackges([]);
        setIsTableHide(true);
    }

    function onCancelClick() {
        clearState();
    }

    const handleClickOpen = () => {
        setOpen(true);
      };
    
      const handleClose = () => {
        setOpen(false);
      };

    return (
        <Fragment>
            <LoadingSpinerComponent />
        <div className="row">
            <div className="col-md-12">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <PageHeader 
                                title="SOS"
                                isButtonEnable={false} 
                                buttonText="Add Factory"
                                path="factories/addEdit" />
                        </div>
                            <hr />

                            <form >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={sos.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityId"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityId"
                                            value={sos.operationEntityId}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntities)}
                                        </Select>
                                        {errors["operationEntityId"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityId"]}</FormHelperText>}
                                    </div>

                                </div>
                                <div className="form-group row">


                                    <div className="col-md">
                                        <InputLabel shrink id="collectionPointID">Collection point</InputLabel>
                                        <Select
                                            fullWidth
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={sos.collectionPointID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Collection point--</MenuItem>
                                            {generateDropDownMenu(collectionpoint)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md">
                                        <InputLabel shrink id="aspNetUserId">User</InputLabel>
                                        <Select
                                            fullWidth
                                            id="aspNetUserId"
                                            name="aspNetUserId"
                                            value={sos.aspNetUserId}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select User--</MenuItem>
                                            {generateDropDownMenu(users)}
                                        </Select>
                                        {errors["aspNetUserId"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["aspNetUserId"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input

                                        type="button"
                                        onClick={(e) => handleSearch(e)}
                                        className="btn btn-primary"
                                        value="Search"
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>

                            </form>


                            <div className="table-responsive row-top-gap" hidden={isTableHide}>
                                <table id="example" className="display dataTable no-footer">
                                    <thead>
                                        <tr>

                                            <th>Package Code</th>
                                            <th>Package Name</th>
                                            <th>Collection Point</th>
                                            {permissionList.isSOSEnabled ? <th>Action</th> : null}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <SoSTableContent
                                            data={packges}
                                            hasEdit={permissionList.isSOSEnabled}
                                            contentRowNames={contentRowNames}
                                            handleClick={handleClick}
                                            actiontype={"SOS"}
                                        />
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}

            />
            <div>
                
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Incompleted Factory Weighments!"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Incompleted Factory Weighment Found,Please Proceed to Complete
                           
                        </DialogContentText>
                        
                    </DialogContent>
                    <DialogActions>
                        <input

                            type="button"
                            onClick={(e) => Proceed(e)}
                            className="btn btn-primary"
                            disabled={!permissionList.isFactoryWeighCompleteEnable}
                            value="Proceed"
                        />
                        <input
                            type="button"
                            className="btn btn-warning pull-right"
                            value="Cancel"
                            onClick={(e) => handleClose()}
                        />
                    </DialogActions>
                </Dialog>
            </div>
        </Fragment>
    );
}


